import React, { memo, useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useField, useForm } from 'react-final-form';
import { FormBlockWrapper } from '../FormBlockWrapper';
import { AdditionalParametersList } from '../../../../AdditionalParametersList';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { useCategoryAdditionalParameters } from '../../../../../hooks/useAdditionalParameters';

const AdditionalParametersComponent = () => {
  const { t } = useTranslation();
  const { change } = useForm();

  const { input: categoryIdField } = useField(FORM_VALUES.categoryId, {
    subscription: { value: true }
  });
  const { input: selectedIdsField } = useField(
    FORM_VALUES.additionalParameters,
    { subscription: { value: true } }
  );

  const { parameters } = useCategoryAdditionalParameters(categoryIdField.value);

  const selectedIds = useMemo<string[]>(
    () => selectedIdsField.value || [],
    [selectedIdsField.value]
  );

  const previousCategoryId = useRef(categoryIdField.value);

  useEffect(() => {
    if (previousCategoryId.current === categoryIdField.value) return;

    previousCategoryId.current = categoryIdField.value;

    if (selectedIds.length) {
      change(FORM_VALUES.additionalParameters, []);
    }
  }, [categoryIdField.value, selectedIds, change]);

  const toggleParameter = useCallback(
    (id: string) => {
      const updatedIds = selectedIds.includes(id)
        ? selectedIds.filter(selectedId => selectedId !== id)
        : [...selectedIds, id];

      change(FORM_VALUES.additionalParameters, updatedIds);
    },
    [selectedIds, change]
  );

  if (!parameters.length) return null;

  return (
    <FormBlockWrapper header={t('new_ad.additional_information')}>
      <AdditionalParametersList
        parameters={parameters}
        selectedIds={selectedIds}
        onToggle={toggleParameter}
        cypress="new-ad-form-additional-parameters"
      />
    </FormBlockWrapper>
  );
};

export const AdditionalParameters = memo(AdditionalParametersComponent);
